import axios from 'axios';

import {Conversation, ConversationChannel, PaginatedData} from 'types';

import {API_URL} from './constants';

const getConversations = async (): Promise<Conversation[]> => {
    const res = await axios.get<Conversation[]>(`${API_URL}/conversations`);
    return res.data;
};

const getChannel = async (conversationId: string, channelId: string): Promise<ConversationChannel> => {
    const res = await axios.get<ConversationChannel>(
        `${API_URL}/conversations/${conversationId}/channels/${channelId}`,
    );
    return res.data;
};

const joinChannel = async (conversationId: string, channelId: string): Promise<Conversation> => {
    const url = `${API_URL}/conversations/${conversationId}/channels/${channelId}/join`;
    const res = await axios.post<Conversation>(url);
    return res.data;
};

const leaveChannel = async (
    conversationId: string,
    channelId: string,
    options?: {message?: string},
): Promise<Conversation> => {
    const url = `${API_URL}/conversations/${conversationId}/channels/${channelId}/leave`;
    const res = await axios.post<Conversation>(url, options ?? {});
    return res.data;
};

const sendMessage = async (
    conversationId: string,
    channelId: string,
    message: string,
): Promise<Conversation> => {
    const url = `${API_URL}/conversations/${conversationId}/channels/${channelId}/send-message`;
    const res = await axios.post<Conversation>(url, {message});
    return res.data;
};

const archiveConversation = async (conversationId: string): Promise<{success: boolean}> => {
    const res = await axios.post<{success: boolean}>(`${API_URL}/conversations/${conversationId}/archive`);
    return res.data;
};

const getArchived = async (page = 1, limit = 10): Promise<PaginatedData<Conversation>> => {
    const res = await axios.get<PaginatedData<Conversation>>(
        `${API_URL}/conversations/archived`,
        {params: {page, limit}},
    );
    return res.data;
};

const rejoinConversation = async (id: string): Promise<{success: boolean; conversationId: string}> => {
    const res = await axios.post<{success: boolean; conversationId: string}>(
        `${API_URL}/conversations/archived/${id}/rejoin`,
    );
    return res.data;
};

export const conversationsApi = {
    getConversations,
    getChannel,
    joinChannel,
    leaveChannel,
    sendMessage,
    archiveConversation,
    getArchived,
    rejoinConversation,
};
